import React, { useState } from "react";
import {
  Box, Typography, FormControl, InputLabel, Select, MenuItem,
  TextField, Button, CircularProgress,
} from "@mui/material";
import { useGetAdminSubmissionsMutation } from "state/api";
import { toast } from "react-toastify";
import * as XLSX from "xlsx";

const Exports = () => {
  const [getAdminSubmissions, { isLoading }] = useGetAdminSubmissionsMutation();
  const [tracker, setTracker] = useState("rx");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const handleExport = async () => {
    try {
      const body = { type: tracker };
      if (startDate) body.from = startDate;
      if (endDate)   body.to   = endDate;
      const res = await getAdminSubmissions(body).unwrap();
      const rows = Array.isArray(res) ? res : [];

      if (rows.length === 0) {
        toast.warn("No data to export");
        return;
      }

      const ws = XLSX.utils.json_to_sheet(rows);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, tracker.toUpperCase());
      XLSX.writeFile(wb, `naari_${tracker}_export_${new Date().toISOString().split("T")[0]}.xlsx`);
      toast.success(`Exported ${rows.length} rows`);
    } catch (err) {
      toast.error(err?.data?.message || "Export failed");
    }
  };

  return (
    <Box sx={{ maxWidth: 500 }}>
      <Typography variant="h5" fontWeight={700} gutterBottom>Export Data</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Download tracker submissions as Excel files.
      </Typography>

      <FormControl fullWidth sx={{ mb: 2 }}>
        <InputLabel>Tracker Type</InputLabel>
        <Select value={tracker} label="Tracker Type" onChange={(e) => setTracker(e.target.value)}>
          <MenuItem value="rx">Rx Tracker</MenuItem>
          <MenuItem value="weekly">Weekly Tracker</MenuItem>
          <MenuItem value="psp">PSP Tracker</MenuItem>
          <MenuItem value="lycored">Lycored Tracker</MenuItem>
        </Select>
      </FormControl>

      <TextField fullWidth type="date" label="Start Date (optional)" value={startDate}
        onChange={(e) => setStartDate(e.target.value)} InputLabelProps={{ shrink: true }} sx={{ mb: 2 }} />
      <TextField fullWidth type="date" label="End Date (optional)" value={endDate}
        onChange={(e) => setEndDate(e.target.value)} InputLabelProps={{ shrink: true }} sx={{ mb: 2 }} />

      <Button fullWidth variant="contained" size="large" onClick={handleExport} disabled={isLoading}>
        {isLoading ? <CircularProgress size={24} /> : "Download Excel"}
      </Button>
    </Box>
  );
};

export default Exports;
